<template>
	<div id="app">
		<div class="hamburger-overlay" @click="hamburgerToggler('main-sidebar')"></div>
		<div class="d-flex h-100 flex-column">
			<div ref="parentForAddingShortKey" class="d-flex h-100 flex-column flex-md-row parent-for-adding-short-keys">
				<div v-show="menuStatus" class="app-nav-menu" id="main-sidebar">
					<nav-menu :parentEl="returnParent" @navigate="navigate" @executeFunction="executeFunction" @focusedItemChanged="focusedItemChanged" @openedItemChanged="openedItemChanged" :selectedItem="menuSelectedItem" :focusedItem="menuFocusedItem" :openedItem="menuOpenedItem" :hash="menuHash" ref="navMenu"></nav-menu>
				</div>
				<div class="app-header">
					<div class="row no-gutters">
						<div class="col-auto ml-auto mt-1">
							<div class="row no-gutters">
								<a class="hamburger-collapse" @click="hamburgerToggler('main-sidebar')" data-toggle="collapse" data-target="#navbarToggleExternalContent" aria-controls="navbarToggleExternalContent">
									<i class="fas fa-bars"></i>
								</a>
							</div>
						</div>
						<div class="part notification pr-1 pl-1 align-items-center d-md-none d-flex" ref="notificationPartSm" style="min-width:40px">
							<div class=" d-flex align-items-center justify-content-center bell-parent">
								<a class=" fas fa-bell p-1" style="font-size:1.5em" @click="showNotificationPopup"></a>
								<div v-if="unseenNotification.length" class="bg-danger circle " style="width: 15px;height:15px;position: relative;top: -8px;left: 10px">
									<div class="d-flex align-items-center" style="font-size: 13px">{{ unseenNotification.length }}</div>
								</div>
							</div>

						</div>
						<div class="user-icon-effect d-flex d-md-none">
							<div class="col-auto d-flex d-md-none text-white user-icon" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<div class="icon buttons-list d-md-none">
									<nk-image v-model="userImage" :options="userImageOptions" />
									<div class="dropdown-menu p-0">
										<div class="dropdown-item p-0">
											<div class="part background-primary user-name col-auto">
												<a @click="userModify"><span class="d-md-none d-block">
													</span><span class="user-name">{{ userFullName }}</span></a>
											</div>
										</div>
										<div class="dropdown-item p-0">
											<div class="part background-primary user-name logout col-auto">
												<a href="#logout" @click="userLogout"><span>
														<nk-image :modelValue="logoutIcon" :options="userImageOptions2" />
													</span><span class="d-md-none d-inline-block mr-2">{{ $t('layout.menu-user-logout') }}</span></a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="app-body" ref="appBody" tabindex="0">
					<nk-module-expiration-warning />
					<div class="top-bar">
						<icon :title="$t('help')" icon="lightbulb" group="regular" class="help" @click="helpSidebarIsFocus = true" ref="helpToggler" />
						<favorite-tabs ref="favTabs" class="top-bar-icon" :currentTabId="activeTab" :visible="favTabsVisible" @visibility-changed="(val) => favTabsVisible = val" />
						<icon :title="$t('general-search.title')" icon="search" group="regular" class="search-icon" @click="searchIconClicked" ref="generalSearch" />
						<HardLoadingWidget v-if="hasLoadingItem" />
						<icon :title="$t('minimal-form')" icon="arrows-to-line" group="regular" class="search-icon" @click="toggleMinimal" />
					</div>
					<nk-tabs :parentEl="returnParent" :activeTab="currentTab" :key="tabsKey" @removed="close" @cleared="tabs_cleared" @changed="activeTabChanged" class="h-100 mt-1">
						<nk-tab v-for="tab in tabs" :key="tab.id" :cachable="tab.cachable" :id="tab.id" :query="tab.query" :name="tab.pageTitle" :sticky="tab.sticky" :buttons="tab.buttons" :passive="tab.passive" @buttonsChanged="tabButtonsChanged" class="nk-tabs-component-section">
							<component ref="tabContent" :is="tab.component" :options="tab.options" :data="tab.data" :closable="true" @buttons-changed="(buttons) => buttonsChanged(tab, buttons)" @title-changed="(title) => titleChanged(tab, title)"></component>
						</nk-tab>
					</nk-tabs>
				</div>
			</div>
			<div class="app-statusbar">
				<div class="row no-gutters">
					<div class="col-auto ml-auto">
						<div class="row no-gutters">
							<div class="part clear-cache col-auto "><a @click.stop="appRefreshClicked" href="#">
									<icon icon="broom" />
								</a></div>
							<div class="part center-title" style="cursor: pointer;width:80px" @click="() => checkVersion(true)">{{ backVersion + '.' + frontVersion }}</div>
							<div class="part fiscal col-auto" :class="{ 'open': fiscalSelectorVisible }" ref="fiscalPart">
								<div class="center-title" @click="() => { fiscalSelectorVisible = !fiscalSelectorVisible }">
									<icon :icon="fiscalSelectorVisible ? 'chevron-down' : 'chevron-up'" class="ml-2" />
									{{ fiscalPeriod.name }}
								</div>
								<div class="fiscal-selector" v-if="fiscalSelectorVisible">
									<nk-popup :options="fiscalPeriodSelectorOptions" @resolve="selectedFiscalPeriodChanged" @close-button-clicked="fiscalSelectorVisible = false"></nk-popup>
								</div>
							</div>
							<div class="part center-title col-auto ml-auto">{{ company.name }}</div>
							<div class="part center-title col-auto ml-auto">{{ company.currency ? company.currency.name : '' }}</div>
							<div class="part center-title col-auto ml-auto hide-1075">{{ dateTime }}</div>
							<div v-if="showHideSalary" class="part col-auto ml-auto salary-section">
								<div class="bg-primary-light salary-indicator d-flex" ref="workshopSelector">
									<div class="workshop col-auto center-title" :class="{ 'open': workshopSelectorVisible }" @click.self="() => { workshopSelectorVisible = !workshopSelectorVisible }">
										<div @click="() => { workshopSelectorVisible = !workshopSelectorVisible }">
											<span style="font-size: 10px;">{{ $t('salary.workshop.title') }}:&nbsp;</span>{{ getWorkshop.name ? getWorkshop.name : '---' }}
										</div>
										<div class="selector" v-if="workshopSelectorVisible">
											<nk-popup :options="workshopSelectorOptions" @resolve="selectedWorkshopChanged"></nk-popup>
										</div>
									</div>
									<div class="px-3 cursor-pointer center-title salary-period" style="background-color: #6e8cb7" @click="openMonthSelector">
										<span style="font-size: 10px;"> {{ $t('salary.salary-period') }}:&nbsp; </span>
										<span> {{ periodDate }} </span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-auto">
						<div class="row no-gutters">
							<div class="part notification pr-1 pl-1 align-items-center d-md-flex d-none" ref="notificationPart" style="min-width:40px">
								<div class=" d-flex align-items-center justify-content-center bell-parent">
									<a class=" fas fa-bell p-1" style="font-size:1.5em" @click="showNotificationPopup"></a>
									<div v-if="unseenNotification.length" class="bg-danger circle " style="width: 15px;height:15px;position: relative;top: -8px;left: 10px">
										<div class="d-flex align-items-center" style="font-size: 13px">{{ unseenNotification.length }}</div>
									</div>
								</div>

							</div>
							<div class="previewPart notification-popup" ref="previewPart" v-show="notificationPopupStatus">
								<nk-popup :options="notificationPopupOptions"></nk-popup>
							</div>
							<div class="part pr-2 pl-2 user col-auto d-md-block d-none">
								<a @click="userModify">
									<span class="user-image d-none d-md-block">
										<nk-image v-model="userImage" :options="userImageOptions" />
									</span>
									<span class="user-name">{{ userFullName }}</span>
								</a>
							</div>
							<div class="part logout col-auto d-md-block d-none">
								<a href="#logout" @click="userLogout"><span>
										<nk-image :modelValue="logoutIcon" :options="userImageOptions2" />
									</span><span class="d-none d-md-inline-block mr-2">{{ $t('layout.menu-user-logout') }}</span></a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<HelpSidebar ref="helpSidebar" :helpTag="tabs.find(tab => tab.id === activeTab)?.helpTag || ''" v-model:visible="helpSidebarIsFocus" />
		<nk-general-search ref="generalSearch" />
		<nk-modal-host :items="modalPages" @showHelp="helpSidebarIsFocus = true"></nk-modal-host>
		<nk-dialog :messages="dialogMessages"></nk-dialog>
		<hard-loading v-if="hasLoadingItem" v-show="!isHardLoadingMinimized" />
		<div v-if="!windowIsFocus && !helpSidebarIsFocus" v-html="$t('app-inactive')" class="app-inactive"></div>
	</div>
</template>
<script>
	import Vue from '~/plugins/vue-instance'
	import $ from 'jquery'
	import _ from 'lodash'
	import { get, post } from '~/plugins/nikan-api'
	import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
	import Fiscals from '~/views/fiscal-periods/fiscal-selector-old'
	import UserInfo from '~/views/useraccount/user-modify'
	import PersianDate from 'persian-date'
	import Endpoints from '@nikan/endpoints'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import Socket from '~/plugins/signalr'
	import { routes } from '~/statics/routes'
	import $sc from "@/plugins/shortcut.collection"
	import cacheCleaner from '~/components/cache/cache-cleaner.vue'
	import NotificationComp from './notifications'
	import FavoriteTabs from '~/components/tabs/favorite-tabs.vue'
	import versionDetailsJson from '@/assets/resources/versionDetails.json'
	import HelpSidebar from '@/components/help/help-sidebar.vue'
	import GeneralSearch from '~/components/general-search/general-search-dropdown.vue'
	import moment from 'jalali-moment'
	import monthSelector from '@/views/salary/salary-period/preview-periods.vue'
	import WorkshopSelector from '~/views/salary/workshop/workshop-selector.vue'
	import HardLoading from '~/components/hard-loading/hard-loading.vue'
	import HardLoadingWidget from '~/components/hard-loading/hard-loading-widget.vue'
	import { getLoadingItem } from '@/plugins/hard-loading'
	import logoutIcon from '@/assets/logout.svg'
	import emptyId from '~/statics/empty-id'
	import { GlobalAppTitle } from '@/plugins/helper'

	let navigateFunc = null

	Vue.config.globalProperties.$openTab = (tab) => {
		if (navigateFunc != null) {
			navigateFunc(tab)
		}
	}

	export default {
		// set forcePush false because vue reouter control route changes byb itself and pushing again would caouse an infinite loop
		// beforeRouteUpdate(to, from, next) {
		// 	next()
		// 	this.menuHash = to.params.page
		// 	this.navigate({ id: this.menuHash }, false)
		// },
		components: {
			'favorite-tabs': FavoriteTabs,
			'nk-general-search': GeneralSearch,
			HelpSidebar,
			HardLoading,
			HardLoadingWidget,
			monthSelector
		},
		data() {
			return {
				logoutIcon,
				stimulInstance: null,
				notifications: [],
				notificationPopupStatus: false,
				tabsKey: 0,
				initDataLoaded: false,
				waitObj: null,
				dateTime: new PersianDate().format('YYYY/MM/DD'),
				backVersion: '...',
				frontVersion: '...',
				tabs: [],
				currentTab: '',
				windowIsFocus: true,
				helpSidebarIsFocus: false,
				fiscalSelectorVisible: false,
				workshopSelectorVisible: false,
				favTabsVisible: false,
				selectedFiscal: null,
				activeTab: null,
				fiscalPeriodSelectorOptions: {
					header: false,
					component: Fiscals,
					data: null,
					options: {},
				},
				workshopSelectorOptions: {
					header: false,
					component: WorkshopSelector,
					data: null,
					options: {},
				},
				userImageOptions: {
					width: 25,
					height: 25,
					defaultImage: 'person2',
					class: 'user-profile-circle user-image',
				},
				userImageOptions2: {
					width: 25,
					height: 25,
					class: 'user-profile-circle user-image',
				},
				userImageUrl: null,
				menuSelectedItem: null,
				menuFocusedItem: null,
				menuOpenedItem: null,
				menuHash: null,
			}
		},
		computed: {
			...mapState({
				modalPages: (state) => state.modals,
				dialogMessages: (state) => state.messages,
			}),
			...mapState('appContext', {
				status: (state) => state,
			}),
			...mapGetters({
				currentUser: 'appContext/getUser',
				cache_get: 'cache/cache_get',
				menuStatus: 'menuStatus',
				get_notifications: 'notifications/all',
				get_unseenNotification: 'notifications/unseen',
				getSalaryPeriod: 'appContext/getSalaryPeriod',
				getWorkshop: 'appContext/getWorkshop',
				isHardLoadingMinimized: 'hardLoading/isMinimized',
				hasLoadingItem: 'hardLoading/hasLoadingItem',
				currentUserDetails: 'useraccount/currentUserDetails',
				getActiveState: 'appStates/getActiveByKey',
			}),
			periodDate() {
				return this.getSalaryPeriod?.displayName ? this.getSalaryPeriod.displayName : '---'
			},
			showHideSalary() {

				if (!this.$nikan.checkCommercialAccess('Salary'))
					return false

				const searchInRoutItems = (obj) => {

					if (this.$route.params && this.$route.params.page === 'home')
						return true

					if (obj.id === this.$route.params.page || this.$route.params?.page?.includes(obj.id)) return true
					if (obj.items) {
						return obj.items.some(x => searchInRoutItems(x))
					}
					return false
				}
				const foundSalary = routes.find(x => x.id === 'salary')
				return searchInRoutItems(foundSalary)

			},
			appIsReady() {
				return this.initDataLoaded && this.$refs.navMenu != null
			},
			userFullName() {
				let u = this.currentUser || {}
				return [u.firstName, u.lastName].join(' ').trim()
			},
			company() {
				return this.status.company ? this.status.company : { currency: {} }
			},
			fiscalPeriod() {
				return this.status.fiscalPeriod ? this.status.fiscalPeriod : {}
			},
			userImage: {
				get: function () {
					return (this.currentUser || {}).imageUrl
				},
				set: function (val) {
					this.userImageUrl = val
				}
			},
			unseenNotification() {
				if (this.get_notifications.length) return this.get_notifications.filter(x => !x.isSeen)
				else return []
			},
			notificationPopupOptions() {
				return {
					header: false,
					component: NotificationComp,
					data: this.get_notifications,
					options: {},
				}
			},
			activeForm() {
				return this.activeTab.split('_')[0]
			},
		},
		watch: {
			appIsReady: {
				handler(val, oldVal) {
					if (val) {
						const r = this.$route
						if (r.name === 'page') {
							this.menuHash = r.params.page
						}

						this.$refs.navMenu.openInitTabs(this.menuHash)

						if (this.waitObj != null) {
							this.waitObj.end()
						}
					}
				},
			},
		},
		created() {
			this.$keyHandler.Reserve('tab-taborder-next')
			this.$keyHandler.Reserve('tab-taborder-previous')
			this.$keyHandler.Reserve('tab-taborder-ctrl-enter-tabscope')
			this.windowFocusChangeCheck()
			this.close_all_dialogs()
			this.close_all_modals()
		},
		mounted() {
			this.waitObj = this.$wait($('body').get(0), { fixed: true })

			this.defer(() => {
				$('body').bind('click', this.bodyClicked.bind(this))


				this.initData()

				get(Endpoints.getUrl('general.version'), null, { ignoreCommercialAccess: true })
					.then((result) => {
						let splitBackVersions = result.data.split('.')
						this.frontVersion = versionDetailsJson.reduce((a, c) => {
							c.frontVersion >= a ? a = c.frontVersion : null
							return a
						}, 0)
						this.backVersion = splitBackVersions.slice(0, splitBackVersions.length - 1).join('.')
						this.checkVersion()
					})
					.catch(() => {
						this.backVersion = 'unable to get backend version'
					})

				if ($('.review-mode-bar').length === 1) {
					console.log($('.review-mode-bar')[0].getBoundingClientRect().height)
					$(this.$refs.appBody).css('height', `calc(100vh - ${$('.review-mode-bar')[0].getBoundingClientRect().height + 34}px)`)
				}
			}, 1)

			navigateFunc = this.navigate
		},
		methods: {
			searchIconClicked() {
				this.$refs.generalSearch.toggle()
			},
			checkVersion(forceToShowTab = false) {
				const localAppVersion = window.localStorage.getItem('app-version')

				if (this.backVersion && this.frontVersion) {
					if ((localAppVersion !== this.backVersion + '.' + this.frontVersion) || forceToShowTab) {
						window.localStorage.setItem('app-version', this.backVersion + '.' + this.frontVersion)
						const foundVersion = versionDetailsJson.find(x => x.backVersion + '.' + x.frontVersion === this.backVersion + '.' + this.frontVersion)
						if (!!foundVersion || forceToShowTab) {
							let route = routes.find(x => x.id == 'version-detail')
							route.options = { currentBackVersion: this.backVersion, currentFrontVersion: this.frontVersion, versions: versionDetailsJson }
							this.navigate(route)
						}
					}
				}
			},
			showNotificationPopup() {
				this.notificationPopupStatus = !this.notificationPopupStatus
				this.ShowUpElementWithAnime(this.notificationPopupStatus, '.notification-popup')
			},
			executeFunction(route) {
				route.func()
			},
			activeTabChanged(obj) {
				this.activeTab = obj.tab.id
				this.focusPage()
			},
			getChildInstance() {
				return this.$refs.comp
			},
			...mapActions({
				close_all_dialogs: 'removeAllMessage',
				close_all_modals: 'removeAllModals',
				refresh_accounts: 'accounts/refresh',
				refresh_auto_accounts: 'autoAccounts/refresh',
				refresh_appStates: 'appStates/refresh',
				refresh_floatingCenters: 'floatingCenters/refresh',
				setFloatingCenterStatus: 'floatingCenters/setStatus',
				refresh_forms: 'forms/refresh',
				refresh_system_forms: 'forms/refreshSystemForms',
				refresh_appContext: 'appContext/refresh',
				refresh_categories: 'floatingCenterCategories/refresh',
				refresh_banks: 'banks/refresh',
				useraccount_clear: 'useraccount/clearUser',
				setFiscalPeriod: 'appContext/setFiscalPeriod',
				setWorkshop: 'appContext/setWorkshop',
				setSalaryPeriod: 'appContext/setSalaryPeriod',
				refresh_currencies: 'currencies/refresh',
				refresh_TodayRatesCurrencies: 'currencies/refreshTodayRates',
				refresh_properties: 'properties/refresh',
				refresh_product_floatings: 'productFloatings/refresh',
				refresh_warehouses: 'warehouses/refresh',
				refresh_fiscalPeriods: 'fiscalPeriods/refresh',
				refresh_frequent_descriptions: 'frequentDescriptions/refresh',
				refresh_metaData: 'metadata/refresh',
				refresh_product_groups: 'productGroups/refresh',
				refresh_product_measureUnits: 'productMeasureUnits/refresh',
				refresh_product_priceLevels: 'productPriceLevels/refresh',
				refresh_userAccount: 'userAccount/refresh',
				refresh_product_classifications: 'productClassifications/refresh',
				refresh_factor_bunches: 'factorBunches/refresh',
				refresh_notification: 'notifications/refresh',
				refresh_workshops: 'workshops/refresh',
				refresh_salaryPeriods: 'salaryPeriods/refresh',
				getUsersForNotification: 'notifications/getUsersForNotification',
				addNotificationToStore: 'notifications/addNotification',
				modifyCenters: 'floatingCenters/modifyCenters',
				updateCenters: 'floatingCenters/updateCenters',
				syncStates: 'appStates/sync',
				modifyStates: 'appStates/modify',
			}),
			...mapMutations({
				update_accounts: 'accounts/update',
				update_floatingCenters: 'floatingCenters/UPDATE',
				itemNotExist: 'formCodes/itemNotExist',
				itemExist: 'formCodes/itemExist',
				addOnlineUsers: 'onlineUsers/add_users',
				addTabToRecentTabs: 'tabHistory/addTabToRecentTabs'
			}),
			openMonthSelector() {
				let options = {
					type: 'selector'
				}
				this.showModal({ component: monthSelector, data: [], options })
					.then((result) => {
						this.selectedSalaryPeriodChanged(result)
					})
					.catch(() => { })
			},
			returnParent() {
				return this.$refs.parentForAddingShortKey
			},
			hamburgerToggler(id) {
				$(`#${id}`).toggleClass('is-active')
				$('.hamburger-overlay').toggleClass('is-active')
			},
			navigate(route) {
				if (_.isString(route)) { // route can be path of target route and paths are splitted by '.' . Example: parent1.child1
					let routeDirectory = route.split('.')
					route = routes.find(x => x.id === routeDirectory[0])
					routeDirectory.shift()
					for (let directory of routeDirectory) {
						route = route.items.find(x => x.id === directory)
					}
				}

				var current = this.tabs.filter(
					(x) => x.id === route.id || x.instanceId === route.id
				)

				if (route.buttons == null) {
					route.buttons = []
				}

				let tab = _.extend(
					{
						title: null,
						buttons: null,
					},
					route
				)

				const canAddMultiple = tab.allowMultiple === true && (!tab.multipleLimit || current.length < tab.multipleLimit)

				if (canAddMultiple && current.length > 0) {
					tab.id += `_${current.length}`
					tab.instanceId = route.id
				}

				if (current.length === 0 || canAddMultiple) {
					this.tabs.push(tab)
				}
				this.addTabToRecentTabs(tab)

				this.currentTab = tab.id
				// this.tabsKey = Math.random()
				// if (forcePush)
				// 	this.$router.push({ name: 'page', params: { page: tab.id } })
				this.menuSelectedItem = tab
				this.focusPage()
			},
			focusedItemChanged(item) {
				this.menuFocusedItem = item
			},
			openedItemChanged(item) {
				this.menuOpenedItem = item
			},
			focusPage() {
				let $els = this.$el.querySelector('.app-body > .nk-tabs-component>.nk-tabs-component-panels> section:not([style="display: none;"]) > div.nk-tabs-component-panel-scroll')
				let $startup = $els?.querySelector('input[startup]')
				let $tabindexes = $els?.querySelector('div[tabindex]')

				// let $els2 = $(this.$el).find(
				// 	'.app-body [role="tabpanel"]:visible .nk-tabs-component-panel-scroll'
				// )
				// let $startup2 = $els2.find('[startup]')
				// let $tabindexes2 = $els2.find('[tabindex]')

				if ($startup) {
					$startup.focus()
				} else if ($tabindexes) {
					$tabindexes.focus()
				} else if ($els) {
					$els.focus()
				}

				this.menuFocusedItem = null
			},
			buttonsChanged(tab, buts) {
				tab.buttons = buts
			},
			titleChanged(tab, title) {
				tab.pageTitle = title
			},
			bodyClicked(sender) {
				if (this.$refs.fiscalPart && !$.contains(this.$refs.fiscalPart, sender.target) && this.fiscalSelectorVisible)
					this.fiscalSelectorVisible = false

				if (this.$refs.workshopSelector && !$.contains(this.$refs.workshopSelector, sender.target) && this.workshopSelectorVisible)
					this.workshopSelectorVisible = false

				if (this.notificationPopupStatus && (this.$refs.notificationPart) &&
					!($.contains(this.$refs.notificationPart, sender.target) || $.contains(this.$refs.notificationPartSm, sender.target)) && !$.contains(this.$refs.previewPart, sender.target)) {

					this.notificationPopupStatus = false
					this.ShowUpElementWithAnime(this.notificationPopupStatus, '.notification-popup')
				}
				if (this.$refs.favTabs && !$.contains(this.$refs.favTabs.$el, sender.target) && this.favTabsVisible)
					this.favTabsVisible = false

				if (this.$refs.helpSidebar && !$.contains(this.$refs.helpSidebar.$el, sender.target) && this.helpSidebarIsFocus && this.$refs.helpToggler.$el !== sender.target && (!document.querySelector('.nm-helpToggler') || !$.contains(document.querySelector('.nm-helpToggler'), sender.target)))
					this.helpSidebarIsFocus = false
			},
			appRefreshClicked() {
				this.showModal({
					component: cacheCleaner,
				})
					.catch((x) => { })
			},
			tabButtonsChanged(id, buttons) {
				let tab = _.head(this.tabs.filter((x) => x.id === id))
				tab.buttons = buttons
			},
			forceEndWaiting() {
				if (this.waitObj != null) {
					this.waitObj.end()
				}
			},

			close(index) {
				this.tabs.splice(index, 1)
				this.currentTab = this.tabs.length ? this.tabs[this.tabs.length - 1].id : ''
			},
			tabs_cleared(tabsToKeep) {
				let cloned = [...this.tabs]
				for (var i = cloned.length - 1; i >= 0; i--) {
					if (tabsToKeep.findIndex((x) => x.id === cloned[i].id) === -1) {
						this.tabs.splice(i, 1)
					}
				}
				this.currentTab = this.tabs.length ? this.tabs[this.tabs.length - 1].id : ''
			},

			initData() {
				const Options = (name) => {
					return {
						force: true,
					}
				}

				this.refresh_appContext(Options('AppContext'))
					.then(res => {

						this.getDataCount().then(res => {
							this.setFloatingCenterStatus(res.data.floatingCentersCount)
							this.refresh_floatingCenters(Options('FloatingCenter'))
								.catch((error) => {
									this.initDataLoaded = true
									this.logger.force(error)
									this.logger.force('Nikan is live but by error in get floating centers')
								})
						})
						let preload = Promise.all([
							this.refresh_properties(Options('Properties')),
							this.refresh_accounts(Options('Account')),
							this.refresh_appStates(Options('AppState')),
							this.refresh_forms(Options('Form')),
							this.refresh_system_forms(Options('Form')),
							this.refresh_categories(Options('Category')),
							this.refresh_banks(Options('Bank')),
							this.refresh_currencies(Options('Currencies')),
							this.refresh_TodayRatesCurrencies(Options('Currencies')),
							this.refresh_product_floatings(Options('ProductFloatings')),
							this.refresh_warehouses(Options('Warehouse')),
							this.refresh_fiscalPeriods(Options('FiscalPeriods')),
							this.refresh_metaData(Options('refresh_MetaData')),
							this.refresh_workshops(Options('Workshops')),
							this.refresh_salaryPeriods(Options('SalaryPeriods')),
						])

						preload
							.then(async () => {
								this.logger.force('Nikan is live')
							})
							.catch((error) => {
								this.initDataLoaded = true
								this.logger.force(error)
								this.logger.force('Nikan is live but by error in preload data')
							})
							.finally(async () => {
								GlobalAppTitle.setCompanyNameOnTitle(this.company.name)

								if (this.$refs.navMenu)
									this.$refs.navMenu.prepareDynamicRoutes()

								this.snapshotInstance.tryFlush(this.status.user.id, this.status.fiscalPeriod.id)
								await this.refresh_auto_accounts(Options('AutoAccount'))
								this.initDataLoaded = true
								Socket.authenticate(this.currentUserDetails.user.access_token, this.fiscalPeriod.id, this.status.user.id, this.status.company.id, this.status.commercialAccess.customerInformation.code, {
									log: false // Active only in development for debugging.
								})
								await this.getUsersForNotification()
								this.refresh_notification()
								// await this.getNotificationsDetail().then(res => this.notifications = res).catch(err => { })

								this.forceEndWaiting()
							})

						this.cache_remove('documentTypes_key')

					})
					.catch(err => { this.forceEndWaiting() })
			},

			selectedFiscalPeriodChanged(item) {
				if (!item?.id)
					return

				if (this.tabs.length > 1) {
					dialog({
						title: this.$t('notifications.titles-warning'),
						body: this.$t('layout.close-all-tabs-to-change-fiscal'),
						type: 'error',
					})
					return
				}
				let fiscal = { id: item.id, name: item.fiscalName }
				this.setFiscalPeriod(fiscal).then(() => {
					this.cache_clear()
					window.bypassCloseConfirmation = true
					window.location.reload()
				})
			},
			selectedWorkshopChanged(item) {
				if (this.tabs.length > 1) {
					dialog({
						title: this.$t('notifications.titles-warning'),
						body: this.$t('layout.close-all-tabs-to-change-workshop'),
						type: 'error',
					})
					return
				}
				this.setWorkshop(item)
					.then(() => {
						this.cache_clear()
						window.bypassCloseConfirmation = true
						window.location.reload()
					})
			},
			selectedSalaryPeriodChanged(item) {
				if (this.tabs.length > 1) {
					dialog({
						title: this.$t('notifications.titles-warning'),
						body: this.$t('layout.close-all-tabs-to-change-period'),
						type: 'error',
					})
				} else {
					this.setSalaryPeriod(item)
						.then(() => {
							// item.callBackFunc && item.callBackFunc()
							this.cache_clear()
							window.bypassCloseConfirmation = true
							window.location.reload()
						})
				}
			},

			windowFocusChangeCheck() {
				$(window).on('blur', () => {
					this.windowIsFocus = false
				})
				$(window).on('focus', () => {
					this.windowIsFocus = true
					this.focusCurrentTab()
				})
				$(window).on('window-active', () => {
					this.focusCurrentTab()
				})
			},
			focusCurrentTab() {
				setTimeout(() => {
					if ($('.nk-dialog .nd-dim').length > -1) {
						$('.nk-dialog .nd-dim .nd-dim-box').focus()
					} else {
						const currentTabEl = $(this.$el).find('.app-body section:visible')
						if (currentTabEl.length > 0) {
							currentTabEl.focus()
							const startupEl = currentTabEl.find('[startup]')
							if (startupEl.length > 0) {
								startupEl[0].focus()
							}
						}
					}
				}, 100)
			},

			userModify() {
				var options = {
					needOldPassword: true,
				}
				this.showModal({ component: UserInfo, data: this.status.user, options })
					.then((result) => { })
					.catch(() => { })
			},
			userLogout(event) {
				event.preventDefault()
				post(Endpoints.getUrl('user.logout-log'), { userId: this.status.user.id })
					.then(res => {
						Socket.stop()
					}).catch(() => {
					}).finally(() => {
						this.useraccount_clear()
						this.$router.push({ name: 'login' })
						GlobalAppTitle.setCompanyNameOnTitle('')
					})
			},
			getDataCount() {
				return post(Endpoints.getUrl('general.dataCount'), {})
			},

			subscribeKeys() {
				if (this.$refs.navMenu) {
					this.$keyHandler.Subscribe({
						name: 'nav-menu-focus',
						keyCode: 77, // 77:M
						altKey: true,
						shiftKey: false,
						ctrlKey: false,
						el: [this.$refs.appBody, this.$refs.navMenu.$el],
						context: this,
						handler: function (sender, e) {
							e.preventDefault()
							if ($(this.$refs.navMenu.$el).is(':focus')) {
								this.focusPage()
							} else {
								this.$refs.navMenu.$el.focus()
							}
						},
					})
					this.$keyHandler.Subscribe({
						name: 'nav-menu-exit',
						keyCode: 27, // 27:escape
						el: this.$refs.navMenu.$el,
						context: this,
						handler: function () {
							this.focusPage()
						},
					})
				}
				if (this.$refs.favTabs) {
					this.$keyHandler.Subscribe({
						shortcut: $sc.find('favorite-tabs'),
						name: 'favorite-tabs',
						context: this,
						el: this.$refs.appBody,
						handler: function (sender, e) {
							this.$refs.favTabs.toggleList()
						},
					})
				}
				if (this.$refs.generalSearch) {
					this.$keyHandler.Subscribe({
						shortcut: $sc.find('search'),
						name: 'general-search',
						context: this,
						el: this.$refs.appBody,
						handler: function (sender, e) {
							this.searchIconClicked()
						},
					})
				}
				if (this.$refs.helpSidebar) {
					this.$keyHandler.Subscribe({
						shortcut: $sc.find('help'),
						name: 'help-window1',
						context: this,
						el: document.getElementById('app'),
						handler: function (sender, e) {
							this.helpSidebarIsFocus = !this.helpSidebarIsFocus
						},
					})
				}
			},
			/**
			 * hide and unhide nav menu
			 */
			hideMenu() {
				this.showMenu = !this.showMenu
			},
			toggleMinimal() {
				let state = this.getActiveState(`minimalPage_${this.activeForm}`)

				if (!state) {
					state = {
						id: emptyId,
						key: `minimalPage_${this.activeForm}`,
						name: `minimalPage_${this.activeForm}`,
						isActive: true,
						rowState: 'new',
						value: true
					}
				} else {
					state.value = !state.value
					state.rowState = 'changed'
				}

				this.modifyStates([state])
				this.syncStates()
			}
		},
		beforeUnmount() {
			$('body').unbind('click')
		},
		sockets: {
			processFactorHawalaNotification(data) {
				const loadingItem = getLoadingItem('bulk-insert-hawala')
				if (loadingItem) {
					loadingItem.updateSucceededCount(data.processedFactorCount)
				}
			},
			nikanNotification(data) {
				this.addNotificationToStore(data)
				this.vibrateElement('.fa-bell')
			},
			onlineUsers(data) {
				// console.log('onlineUsers', data)
				this.addOnlineUsers(data)
			},
			centerChanges(data) {
				console.log("🚀 ~ centerChanges ~ data:", data)
				this.$emitter.emit('updateFloatingCentersBalance', data)
				// this.$emitter.emit('updateFloatingCentersBalance', data.map(x => {
				// 	Object.keys(x).forEach(y => {
				// 		x[y] = x[y].toString()
				// 	})
				// 	return { ...x, id: x.floatingCenterId }
				// }))
				this.modifyCenters(data)
			},
			notifyCenter(data) {
				this.updateCenters(data).then((res) => {
					this.$emitter.emit('updatedFloatingCenters', data)
				})
			},
			itemNotExist(data) {
				console.log('socket-itemNotExist', data)
				this.itemNotExist({ form: data.form, code: data.code, additionalBroadcastFields: data.additionalBroadcastFields })
			},
			itemExist(data) {
				console.log('socket-itemExist', data)
				this.itemExist({ form: data.form, code: data.code, additionalBroadcastFields: data.additionalBroadcastFields })
			},
			refresh_accounts(newAccount) {
				this.update_accounts(newAccount)
			},
			refresh_centers(newCenter) {
				this.update_centers(newCenter)
			},
			refresh(type) {
				console.log('socket-refresh', type)
				switch (type) {

					case 'Bank':
						this.refresh_banks({ force: true })
						break

					case 'Currencies':
						this.refresh_currencies({ force: true })
						this.refresh_TodayRatesCurrencies({ force: true })
						break

					case 'FiscalPeriod':
						this.refresh_fiscalPeriods({ force: true })
						break

					case 'AutoAccount':
						this.refresh_auto_accounts({ force: true })
						break

					case 'Categories':
						this.refresh_categories({ force: true })
						break

					case 'Froms':
						this.refresh_forms({ force: true })
						break

					case 'FrequentDescription':
						this.refresh_frequent_descriptions({ force: true })
						break

					case 'MetaData':
						this.refresh_metaData({ force: true })
						break

					case 'ProductFloatings':
						this.refresh_product_floatings({ force: true })
						break

					case 'ProductGroups':
						this.refresh_product_groups({ force: true })
						break

					case 'ProductMeasureUnits':
						this.refresh_product_measureUnits({ force: true })
						break

					case 'ProductPriceLevels':
						this.refresh_product_priceLevels({ force: true })
						break

					case 'Properties':
						this.refresh_properties({ force: true })
						break

					case 'UserAccount':
						this.refresh_userAccount()
						break

					case 'Warehouses':
						this.refresh_warehouses({ force: true })
						break

					case 'Accounts':
						this.refresh_accounts({ force: true })
						break

					case 'FloatingCenters':
						this.refresh_floatingCenters({ force: true })
						break

					case 'ProductClassifications':
						this.refresh_product_classifications({ force: true })
						break

					case 'FactorBunches':
						this.refresh_factor_bunches({ force: true })
						break

					default:
						break
				}
			},
			processImportFactorFromExcelNotification(data) {
				const loadingItem = getLoadingItem(data.fileId)
				if (loadingItem) {
					loadingItem.updateTotalItems(data.totalFactorCount)
					loadingItem.updateSucceededCount(data.processedFactorCount)
				}
			},
			processRializationNotification(data) {
				const loadingItem = getLoadingItem('rialization')
				if (loadingItem) {
					loadingItem.updateTotalItems(data.totalHawalaCount)
					loadingItem.updateSucceededCount(data.processedHawalaCount)
				}
			},
			processImportDocumentFromExcelNotification(data) {
				const loadingItem = getLoadingItem(data.fileId)
				if (loadingItem) {
					loadingItem.updateTotalItems(data.totalDocumentCount)
					loadingItem.updateSucceededCount(data.processedDocumentCount)
				}

			},
		},
	}
</script>
<style src="~/styles/site.less"
	lang="less"></style>
